<template>
  <div>
    <super-body-form
      v-if="$route.params.body_type == 'super'"
      :body_member_data="getBodyMemberData"
    ></super-body-form>
    <executive-body-form
      v-if="$route.params.body_type == 'executive'"
      :body_member_data="getBodyMemberData"
    ></executive-body-form>
    <other-body-form
      v-if="$route.params.body_type == 'other'"
      :body_member_data="getBodyMemberData"
    ></other-body-form>
  </div>
</template>
<script>
import SuperBodyForm from "./06_3_1_SuperBodyForm";
import ExecutiveBodyForm from "./06_3_2_ExecutiveBodyForm";
import OtherBodyForm from "./06_3_3_OtherBodyForm";
export default {
  props: ["user_profile"],
  components: {
    SuperBodyForm,
    ExecutiveBodyForm,
    OtherBodyForm
  },
  computed: {
    getBodyMemberData() {
      if (this.$route.params.member_id && this.user_profile) {
        let members = this.user_profile.userControls.members || [];
        return this.$route.params.member_id
          ? members.filter(
              member => member.id == this.$route.params.member_id
            )[0]
          : null;
      }
    }
  }
};
</script>
